import { FieldArray, useFormikContext } from 'formik';
import { isSackwareView } from '../../../helper/bestellungen-helper';
import { SackwareListEntryExistingBestellung } from './ExistingBestellung/SackwareListEntryExistingBestellung';
import { ArtikelTableValues } from '../../../types';
import { useSelector } from 'react-redux';
import { selectIsBestellungExisting } from '../../../../store/Global.selectors';
import { SackwareListEntryNewBestellung } from './NewBestellung/SackwareListEntryNewBestellung';

interface Props {
    onArtikelDeleted?: (artikelNummer: string) => void;
    allowDelete?: boolean;
    editablePositions?: Record<string, boolean>;
}

export const SackwareList = ({ onArtikelDeleted, allowDelete, editablePositions }: Props): JSX.Element => {
    const formikProps = useFormikContext<ArtikelTableValues>();
    const isExisting = useSelector(selectIsBestellungExisting);

    const ListEntry = isExisting ? SackwareListEntryExistingBestellung : SackwareListEntryNewBestellung;

    const filteredPositions = formikProps.values.bestellpositionenView
        .filter(isSackwareView)
        .filter((position) => position.nummer && position.nummer.trim() !== '') // Filter out positions without artikelnummer
        .filter((position) => {
            if (editablePositions === undefined) {
                return true; // If no filter provided, show all
            }
            return editablePositions[position.nummer] === true;
        });

    return (
        <div>
            <FieldArray
                name="bestellpositionenView"
                render={(arrayHelpers): JSX.Element => (
                    <>
                        {filteredPositions.map((bestellposition, index) => {
                            return (
                                <ListEntry
                                    key={index}
                                    bestellposition={bestellposition}
                                    arrayHelpers={arrayHelpers}
                                    onArtikelDeleted={onArtikelDeleted}
                                    allowDelete={allowDelete}
                                />
                            );
                        })}
                    </>
                )}
            />
        </div>
    );
};
